import React, { useRef } from "react";
import { FaBriefcase } from "react-icons/fa";
import "./Experience.css";
import { useFirebaseDatabaseRootData } from "../../context/FirebaseDatabaseRootDataContext";

const Experience = () => {
  const { rootData, rootDataLoading, rootDataError } = useFirebaseDatabaseRootData();
  const experienceData = rootData?.experience || [];

  if (rootDataLoading) {
    return <div className="experience-wrapper">Loading experience...</div>;
  }
  if (rootDataError) {
    return <div className="experience-wrapper">Error loading experience: {rootDataError}</div>;
  }
  if (!experienceData.length) {
    return <div className="experience-wrapper">No experience data found.</div>;
  }

  const TimelineItem = ({ item }) => {
    const cardRef = useRef(null);

    const handleMouseMove = (e) => {
      if (!cardRef.current) return;
      const rect = cardRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      cardRef.current.style.setProperty("--x", `${x}px`);
      cardRef.current.style.setProperty("--y", `${y}px`);
    };

    return (
      <div className="timeline-item">
        <div className="timeline-dot">
          <FaBriefcase />
        </div>
        <div className="timeline-date">{item.date}</div>
        <div
          className="timeline-content"
          ref={cardRef}
          onMouseMove={handleMouseMove}
        >
          <div
            className="timeline-thumb"
            style={{ backgroundImage: `url(${item.image})` }}
          ></div>
          <h3 className="timeline-role">{item.role}</h3>
          <h4 className="timeline-company">{item.company}</h4>
          <p className="timeline-description">{item.description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="experience-wrapper">
      <h2 className="experience-title">My Journey</h2>
      <div className="experience-timeline">
        {experienceData.map((item, index) => (
          <TimelineItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
};

export default Experience;
